import React from 'react';
import { SyncOutlined } from '@ant-design/icons';
import {
	Combobox,
	ComboboxInput,
	ComboboxContent,
	ComboboxList,
	ComboboxItem,
	ComboboxEmpty,
} from '@hydrodigital/combobox';
import { Tooltip } from '@hydrodigital/design-system';
import { optionsInterval } from '../constants';
import TooltipLabel from './TooltipLabel';

interface IntervalSelectorProps {
	intervalRefresh: number;
	isSmallScreen: boolean;
	onChangeInterval: (value: number) => void;
}

const IntervalSelector: React.FC<IntervalSelectorProps> = ({
	intervalRefresh,
	isSmallScreen,
	onChangeInterval,
}) => (
	<Tooltip
		position="left"
		trigger="hover"
		minWidth={120}
		slot={
			<TooltipLabel height={30}>
				Automatically refreshes the data and map view at the selected time interval.
			</TooltipLabel>
		}
	>
		<div
			className="interval-combobox-wrapper"
			style={{
				width: isSmallScreen ? 100 : 110,
				minWidth: isSmallScreen ? 105 : 110,
				height: 32,
			}}
		>
			<Combobox
				items={optionsInterval.map((option) => ({
					value: String(option.value),
					label: option.label,
				}))}
				value={String(intervalRefresh)}
				onValueChange={(val) => {
					onChangeInterval(Number(val));
				}}
				size="small"
			>
				<ComboboxInput
					placeholder="Select interval"
					leftIcon={<SyncOutlined style={{ fontSize: 16, color: '#434B56' }} rev={undefined} />}
				/>
				<ComboboxContent>
					<ComboboxEmpty>No options found.</ComboboxEmpty>
					<ComboboxList>
						{(item) => (
							<ComboboxItem key={item.value} value={item} style={{ width: '100%' }}>
								<Tooltip
									position="right"
									trigger="hover"
									minWidth={140}
									className="interval-item-tooltip"
									slot={
										<div
											style={{
												fontSize: 12,
												lineHeight: '16px',
												padding: '6px 8px',
												borderRadius: 6,
											}}
										>
											{optionsInterval.find((option) => String(option.value) === item.value)?.tooltip}
										</div>
									}
								>
									<div
										style={{
											display: 'flex',
											width: '100%',
											height: '100%',
											flexDirection: 'row',
											alignItems: 'center',
											padding: '0 48px 0 8px',
											overflow: 'visible',
										}}
									>
										{item.label}
									</div>
								</Tooltip>
							</ComboboxItem>
						)}
					</ComboboxList>
				</ComboboxContent>
			</Combobox>
		</div>
	</Tooltip>
);

export default IntervalSelector;
